import { copyDeep } from '@/shared'
import {
    IPayloadSearchInquiryFqa,
    IStateStoreAnnouncementAdminFQA
} from '@/modules/adminFQA/modules/inquiry/shared/@types'
import InquiryAdminFQAService from '@/modules/adminFQA/modules/inquiry/services'
import { HttpStatusCode, TypeNotify } from '@/shared/enums'
import {
    customUrlImage,
    customUrlPdf,
    NotificationCustom,
    objectHasKey
} from '@/shared/function'
import AnnounceAdminFQAService from '@/modules/adminFQA/modules/announcement/services'
import { IPayloadSearchAnnounce } from '@/shared/@types'
import AnnounceAdvisorService from '@/modules/advisor/modules/announcement/services'
import router from '@/router'
import { RouterAdminFQA } from '@/modules/adminFQA/shared/enums'
import { IParamUpdateStatusAnnouncementById } from '@/modules/adminFQA/modules/announcement/shared/@types'

export const defaultStateAnnouncementAdminFqa: IStateStoreAnnouncementAdminFQA =
    {
        data: {}
    }

const state = () => copyDeep(defaultStateAnnouncementAdminFqa)

const getters = {
    getDataAnnouncementFqa(state: IStateStoreAnnouncementAdminFQA) {
        return state.data
    }
}

const mutations = {
    setDataAnnouncementAdminFqa(
        state: IStateStoreAnnouncementAdminFQA,
        payload: any
    ) {
        state.data = payload
    }
}

const actions = {
    async getDataAnnouncementAdminFqa(
        { commit }: any,
        payload: IPayloadSearchAnnounce
    ) {
        commit('popup/setLoading', true, { root: true })
        try {
            const res = await AnnounceAdminFQAService.apiGetAnnounce(payload)
            const { status, data } = res
            if (status === HttpStatusCode.ok) {
                commit('setDataAnnouncementAdminFqa', data.data)
                return
            }
            NotificationCustom({
                type: TypeNotify.error,
                message: data.errors.error_message
            })
        } catch (e) {
        } finally {
            commit('popup/setLoading', false, { root: true })
        }
    },
    async getDataDetailAnnouncement({ commit }: any, id: number) {
        commit('popup/setLoading', true, { root: true })
        try {
            const res = await AnnounceAdminFQAService.apiGetAnnounceDetail(id)
            const { status, data } = res
            if (status === HttpStatusCode.ok) {
                if (data.data && objectHasKey(data.data, 'file_link')) {
                    data.data.file_link = customUrlPdf(data.data.file_link)
                }

                commit('setDataAnnouncementAdminFqa', data.data)
                return data.data
            }
            NotificationCustom({
                type: TypeNotify.error,
                message: data.errors.error_message
            })
            await router.push(RouterAdminFQA.announcement)
        } catch (e) {
        } finally {
            commit('popup/setLoading', false, { root: true })
        }
    },
    async updateStatusAnnouncement({ commit }: any) {
        commit('popup/setLoading', true, { root: true })
        try {
            const res = await AnnounceAdminFQAService.apiUpdateStatusAnnounce()
            const { status, data } = res
            if (status === HttpStatusCode.ok) {
                return true
            }
            NotificationCustom({
                type: TypeNotify.error,
                message: data.errors.error_message
            })
        } catch (e) {
        } finally {
            commit('popup/setLoading', false, { root: true })
        }
    },
    async updateStatusAnnouncementById(
        { commit }: any,
        payload: IParamUpdateStatusAnnouncementById
    ) {
        try {
            const res =
                await AnnounceAdminFQAService.apiUpdateStatusAnnounceById(
                    payload
                )
            const { status, data } = res
            if (status === HttpStatusCode.ok) {
                return
            }
            NotificationCustom({
                type: TypeNotify.error,
                message: data.errors.error_message
            })
        } catch (e) {}
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
